<template>
  <div>
    <button
      class="btn btn-primary btn-sm"
      data-toggle="tooltip"
      data-placement="top"
      title="New"
      @click="fnShowModal()"
    >
      New
    </button>

    <b-modal ref="modal" hide-footer title="Financier - new">
      <div class="d-block">
        <form v-on:submit.prevent="createNew">
          <div class="form-group">
            <label for="name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              placeholder="Name"
              v-model="name"
            />
            <div class="invalid-feedback" v-if="errors.name">
              {{ errors.name[0] }}
            </div>
          </div>

          <div class="form-group">
            <label for="name">Rate</label>
            <input
              type="number"
              class="form-control"
              placeholder="Rate"
              v-model="rate"
            />
            <div class="invalid-feedback" v-if="errors.rate">
              {{ errors.rate[0] }}
            </div>
          </div>

          <div class="form-group">
            <label for="name">Description</label>
            <input
              type="text"
              class="form-control"
              id="description"
              placeholder="Description"
              v-model="description"
            />
          </div>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as financierService from '../../services/financier.service'
export default {
  name: 'ModalFinancierNew',
  components: {},
  data() {
    return {
      errors: {},
      name: '',
      rate: 0,
      description: ''
    }
  },
  methods: {
    ...mapActions(['fetchFinancierAll']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    createNew: async function () {
      let formData = new FormData()
      formData.append('name', this.name)
      formData.append('rate', this.rate)
      formData.append('description', this.description)
      try {
        const response = await financierService.add(formData)
        this.hideModal()
        this.fetchFinancierAll()

        messageService.fnSweetAlertSuccessToast(
          'Financier - new',
          'added successfully'
        )

        this.name = ''
        this.description = ''
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Financier - new',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Financier - new',
              'Something wrong'
            )
            break
        }
      }
    }
  }
}
</script>
